import { FC } from 'react';
import { useTranslation } from 'next-i18next';
import { UserDetails } from 'src/common/types/api/v4/boats/search';
import Typography from 'src/common/components/Typography';
import Modal from 'src/common/components/ModalDS22';
import Avatar from 'src/common/components/Avatar';
import styles from './DescriptionModal.module.scss';

const {
  ControllerDS22: Controller,
} = Modal;

export type DescriptionModalProps = {
  boatOwner: UserDetails;
  description: string;
  isOpen: boolean;
  close: () => void;
};

const DescriptionModal: FC<DescriptionModalProps> = ({
  boatOwner,
  description,
  isOpen,
  close,
}) => {
  const [t] = useTranslation('listing-page');
  return (
    <Modal
      modalOpen={isOpen}
      closeModal={close}
      label={t('owner-description--title')}
      position="right"
      size="medium"
    >
      <Controller onClose={close} />
      <div className={styles.divider} />
      <div className={styles.content}>
        <div className={styles.ownerInfo}>
          <div className={styles.avatar}>
            <Avatar
              user={boatOwner}
              size="medium"
              classNameModifier="noMargin"
            />
          </div>
          <Typography type="h2" size="heading-5" weight="semibold">
            {t('owner-description--title')}
          </Typography>
        </div>
        <p className={styles.description}>
          {description}
        </p>
      </div>
    </Modal>
  );
};

export default DescriptionModal;
